function parseJsonField(value) {
  if (value == null) return null;
  if (typeof value === 'object' && !Array.isArray(value)) return value;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return null;
    try {
      return JSON.parse(trimmed);
    } catch {
      return null;
    }
  }
  return null;
}

function phoneFromTempEmail(email) {
  if (!email || typeof email !== 'string') return null;
  const match = String(email).trim().match(/^phone_(\d+)@temp\.liberty$/i);
  if (!match) return null;
  const digits = match[1];
  if (!digits) return null;
  if (digits.startsWith('216')) return `+${digits}`;
  return `+216${digits}`;
}

export function resolveUserPhone(user) {
  if (!user || typeof user !== 'object') return null;

  const direct = String(user.phone ?? '').trim();
  if (direct) return direct;

  const meta = parseJsonField(user.metadata);
  if (meta) {
    const candidates = [meta.phone, meta.phoneNumber, meta.mobile, meta.telephone];
    for (const candidate of candidates) {
      const normalized = candidate != null ? String(candidate).trim() : '';
      if (normalized) return normalized;
    }
  }

  return phoneFromTempEmail(user.email);
}

export function formatUserPhoneDisplay(user) {
  return resolveUserPhone(user) || 'Non renseigné';
}
